// USE IN EVERY PAGE
import DeluxeSwissCottageIcon from '../assets/icon/deluxe-swiss-cottage-icon.png';
import PremiumSwissCottageIcon from '../assets/icon/premium-swiss-cottage-icon.png';
import RoyalLuxurySwissCottageIcon from '../assets/icon/royal-luxury-swiss-cottage-icon.png';
import PresidentialSuiteIcon from '../assets/icon/presidental-suite-swiss-cottage-icon.png';

import Activity1 from '../assets/icon/activity/travel.png'
import Activity2 from '../assets/icon/activity/quad.png'
import Activity3 from '../assets/icon/activity/guitar-playing.png'
import Activity4 from '../assets/icon/activity/yoga.png'
import Activity5 from '../assets/icon/activity/brochette.png'
import Activity6 from '../assets/icon/activity/map.png'
import Activity7 from '../assets/icon/activity/plant.png'
import Activity8 from '../assets/icon/activity/video.png'
import Activity9 from '../assets/icon/activity/celebration.png'



// KONARK
import Konark1 from "../assets/eco-retreat/konark/gallery/konark1.jpg";
import Konark2 from "../assets/eco-retreat/konark/gallery/konark2.jpg";
import Konark3 from "../assets/eco-retreat/konark/gallery/konark3.jpg";
import Konark4 from "../assets/eco-retreat/konark/gallery/konark4.jpg";
import Konark5 from "../assets/eco-retreat/konark/gallery/konark5.jpg";
import Konark6 from "../assets/eco-retreat/konark/gallery/konark6.jpg";
import Konark7 from "../assets/eco-retreat/konark/gallery/konark7.jpg";
import Konark8 from "../assets/eco-retreat/konark/gallery/konark8.jpg";
import Konark9 from "../assets/eco-retreat/konark/gallery/konark9.jpg";
import Konark10 from "../assets/eco-retreat/konark/gallery/konark10.jpg";
import Konark11 from "../assets/eco-retreat/konark/gallery/konark11.jpg";
import Konark12 from "../assets/eco-retreat/konark/gallery/konark12.jpg";
import Konark13 from "../assets/eco-retreat/konark/gallery/konark13.jpg";
import Konark14 from "../assets/eco-retreat/konark/gallery/konark14.jpg";
import Konark15 from "../assets/eco-retreat/konark/gallery/konark15.jpg";
import Konark16 from "../assets/eco-retreat/konark/gallery/konark16.jpg";
import Konark17 from "../assets/eco-retreat/konark/gallery/konark17.jpg";
import Konark18 from "../assets/eco-retreat/konark/gallery/konark18.jpg";
import Konark19 from "../assets/eco-retreat/konark/gallery/konark19.jpg";
import Konark20 from "../assets/eco-retreat/konark/gallery/konark20.jpg";
import Konark21 from "../assets/eco-retreat/konark/gallery/konark21.jpg";
import Konark22 from "../assets/eco-retreat/konark/gallery/konark22.jpg";
import Konark23 from "../assets/eco-retreat/konark/gallery/konark23.jpg";
import Konark24 from "../assets/eco-retreat/konark/gallery/konark24.jpg";
import Konark25 from "../assets/eco-retreat/konark/gallery/konark25.jpg";
import Konark26 from "../assets/eco-retreat/konark/gallery/konark26.jpg";
import Konark27 from "../assets/eco-retreat/konark/gallery/konark27.jpg";

import KonarkDeluxeSwissCottage from '../assets/eco-retreat/konark/room/Deluxe-Swiss-Cottage/deluxe-swiss-cottage1.jpg';
import KonarkPremiumSwissCottage from '../assets/eco-retreat/konark/room/Premium-Swiss-Cottage/premium-swiss-cottage1.jpg';
import KonarkRoyalLuxurySwissCottage from '../assets/eco-retreat/konark/room/Royal-Luxury-Swiss-Cottage/royal-luxury-deluxe-swiss-cottage1.jpg';
import KonarkPresidentialSuite from '../assets/eco-retreat/konark/room/Presidential-Suite/presidential-suite1.jpg';

import KonarkSunTemple from '../assets/attractions/konark/Konark-sun-temple.jpg';
import KonarkAsiMuseum from '../assets/attractions/konark/ASI-Museum.jpg';
import KonarkJagannathPuri from '../assets/attractions/konark/jagannath-puri.jpg';

import KonarkExploreImg from '../assets/eco-retreat/konark/explore/Dining-hall.jpg';

// SATKOSIA
import Satkosia1 from "../assets/eco-retreat/satkosia/gallery/satkosia1.jpg";
import Satkosia2 from "../assets/eco-retreat/satkosia/gallery/satkosia2.jpg";
import Satkosia3 from "../assets/eco-retreat/satkosia/gallery/satkosia3.jpg";
import Satkosia4 from "../assets/eco-retreat/satkosia/gallery/satkosia4.jpg";
import Satkosia5 from "../assets/eco-retreat/satkosia/gallery/satkosia5.jpg";
import Satkosia6 from "../assets/eco-retreat/satkosia/gallery/satkosia6.jpg";
import Satkosia7 from "../assets/eco-retreat/satkosia/gallery/satkosia7.jpg";
import Satkosia8 from "../assets/eco-retreat/satkosia/gallery/satkosia8.jpg";
import Satkosia9 from "../assets/eco-retreat/satkosia/gallery/satkosia9.jpg";
import Satkosia10 from "../assets/eco-retreat/satkosia/gallery/satkosia10.jpg";
import Satkosia11 from "../assets/eco-retreat/satkosia/gallery/satkosia11.jpg";
import Satkosia12 from "../assets/eco-retreat/satkosia/gallery/satkosia12.jpg";
import Satkosia13 from "../assets/eco-retreat/satkosia/gallery/satkosia13.jpg";
import Satkosia14 from "../assets/eco-retreat/satkosia/gallery/satkosia14.jpg";
import Satkosia15 from "../assets/eco-retreat/satkosia/gallery/satkosia15.jpg";

import SatkosiaDeluxeSwissCottage from '../assets/eco-retreat/satkosia/room/Deluxe-Swiss-Cottage/deluxe-swiss-cottage1.jpg';
import SatkosiaPremiumSwissCottage from '../assets/eco-retreat/satkosia/room/Premium-Swiss-Cottage/premium-swiss-cottage1.jpg';

import SatkosiaTigerReserve from '../assets/attractions/satkosia/tiger-reserve.jpg';
import RatnagandaWaterfall from '../assets/attractions/satkosia/waterfall.jpg';
import SatkosiaGorgeSanactuary from '../assets/attractions/satkosia/Satkosia-Gorge-Sanctuary.jpg';

import SatkosiaExploreImg from '../assets/eco-retreat/satkosia/explore/satkosia-dining-1.jpg';

// PUTSIL
import Putsil1 from "../assets/eco-retreat/putsil/gallery/putsil1.jpg";
import Putsil2 from "../assets/eco-retreat/putsil/gallery/putsil2.jpg";
import Putsil3 from "../assets/eco-retreat/putsil/gallery/putsil3.jpg";
import Putsil4 from "../assets/eco-retreat/putsil/gallery/putsil4.jpg";
import Putsil5 from "../assets/eco-retreat/putsil/gallery/putsil5.jpg";
import Putsil6 from "../assets/eco-retreat/putsil/gallery/putsil6.jpg";
import Putsil7 from "../assets/eco-retreat/putsil/gallery/putsil7.jpg";
import Putsil8 from "../assets/eco-retreat/putsil/gallery/putsil8.jpg";
import Putsil9 from "../assets/eco-retreat/putsil/gallery/putsil9.jpg";
import Putsil10 from "../assets/eco-retreat/putsil/gallery/putsil10.jpg";
import Putsil11 from "../assets/eco-retreat/putsil/gallery/putsil11.jpg";
import Putsil12 from "../assets/eco-retreat/putsil/gallery/putsil12.jpg";

import PutsilDeluxeSwissCottage from '../assets/eco-retreat/putsil/room/Deluxe-Swiss-Cottage/deluxe-swiss-cottage1.jpg';
import PutsilPremiumSwissCottage from '../assets/eco-retreat/putsil/room/Premium-Swiss-Cottage/premium-swiss-cottage1.jpg';

import SabarSrikhetra from '../assets/attractions/putsil/SABAR-SRIKHETRA.jpg';
import TribalMuseum from '../assets/attractions/putsil/tribal-museum.jpg';
import DudumaWaterfalls from '../assets/attractions/putsil/duduma-waterfalls.jpg';

import PutsilExploreImg from '../assets/eco-retreat/putsil/explore/koraput-landscape.jpg';

// SONAPUR
import Sonapur1 from "../assets/eco-retreat/sonapur/gallery/sonapur1.jpg";
import Sonapur2 from "../assets/eco-retreat/sonapur/gallery/sonapur2.jpg";
import Sonapur3 from "../assets/eco-retreat/sonapur/gallery/sonapur3.jpg";
import Sonapur4 from "../assets/eco-retreat/sonapur/gallery/sonapur4.jpg";
import Sonapur5 from "../assets/eco-retreat/sonapur/gallery/sonapur5.jpg";
import Sonapur6 from "../assets/eco-retreat/sonapur/gallery/sonapur6.jpg";
import Sonapur7 from "../assets/eco-retreat/sonapur/gallery/sonapur7.jpg";
import Sonapur8 from "../assets/eco-retreat/sonapur/gallery/sonapur8.jpg";
import Sonapur9 from "../assets/eco-retreat/sonapur/gallery/sonapur9.jpg";
import Sonapur10 from "../assets/eco-retreat/sonapur/gallery/sonapur10.jpg";
import Sonapur11 from "../assets/eco-retreat/sonapur/gallery/sonapur11.jpg";
import Sonapur12 from "../assets/eco-retreat/sonapur/gallery/sonapur12.jpg";

import SonapurDeluxeSwissCottage from '../assets/eco-retreat/sonapur/room/Deluxe-Swiss-Cottage/deluxe-swiss-cottage1.jpg';
import SonapurPremiumSwissCottage from '../assets/eco-retreat/sonapur/room/Premium-Swiss-Cottage/premium-swiss-cottage1.jpg';

import SureswariTemple from '../assets/attractions/sonapur/Sureswari-temple.jpg';
import LankeswariTemple from '../assets/attractions/sonapur/LANKESWARI-TEMPLE_.jpg';
import SubarnameruShivaTemple from '../assets/attractions/sonapur/Subarnameru-Shiva-Temple.jpg';

import SonapurExploreImg from '../assets/eco-retreat/sonapur/explore/sonapur-parasailing.jpg';

// DARINGBADI
import Daringbadi1 from "../assets/eco-retreat/daringbadi/gallery/daringbadi1.jpg";
import Daringbadi2 from "../assets/eco-retreat/daringbadi/gallery/daringbadi2.jpg";
import Daringbadi3 from "../assets/eco-retreat/daringbadi/gallery/daringbadi3.jpg";
import Daringbadi4 from "../assets/eco-retreat/daringbadi/gallery/daringbadi4.jpg";
import Daringbadi5 from "../assets/eco-retreat/daringbadi/gallery/daringbadi5.jpg";
import Daringbadi6 from "../assets/eco-retreat/daringbadi/gallery/daringbadi6.jpg";
import Daringbadi7 from "../assets/eco-retreat/daringbadi/gallery/daringbadi7.jpg";
import Daringbadi8 from "../assets/eco-retreat/daringbadi/gallery/daringbadi8.jpg";
import Daringbadi9 from "../assets/eco-retreat/daringbadi/gallery/daringbadi9.jpg";
import Daringbadi10 from "../assets/eco-retreat/daringbadi/gallery/daringbadi10.jpg";
import Daringbadi11 from "../assets/eco-retreat/daringbadi/gallery/daringbadi11.jpeg";
import Daringbadi12 from "../assets/eco-retreat/daringbadi/gallery/daringbadi12.jpg";
import Daringbadi13 from "../assets/eco-retreat/daringbadi/gallery/daringbadi13.jpeg";
import Daringbadi14 from "../assets/eco-retreat/daringbadi/gallery/daringbadi14.jpg";
import Daringbadi15 from "../assets/eco-retreat/daringbadi/gallery/daringbadi15.jpeg";

import DaringbadiDeluxeSwissCottage from '../assets/eco-retreat/daringbadi/room/Deluxe-Swiss-Cottage/deluxe-swiss-cottage1.jpg';
import DaringbadiPremiumSwissCottage from '../assets/eco-retreat/daringbadi/room/Premium-Swiss-Cottage/premium-swiss-cottage1.jpg';

import SunsetPoint from '../assets/attractions/daringbadi/sunset-point.jpg';
import MidubandaWaterfall from '../assets/attractions/daringbadi/Midubanda-waterfall.jpg';
import CoffeeGarden from '../assets/attractions/daringbadi/coffee-garden.jpg';

import DaringbadiExploreImg from '../assets/eco-retreat/daringbadi/explore/daringbadi-dining.jpg';

// HIRAKUD
import Hirakud1 from "../assets/eco-retreat/hirakud/gallery/hirakud1.jpg";
import Hirakud2 from "../assets/eco-retreat/hirakud/gallery/hirakud2.jpg";
import Hirakud3 from "../assets/eco-retreat/hirakud/gallery/hirakud3.jpg";
import Hirakud4 from "../assets/eco-retreat/hirakud/gallery/hirakud4.jpg";
import Hirakud5 from "../assets/eco-retreat/hirakud/gallery/hirakud5.jpg";
import Hirakud6 from "../assets/eco-retreat/hirakud/gallery/hirakud6.jpg";
import Hirakud7 from "../assets/eco-retreat/hirakud/gallery/hirakud7.jpg";
import Hirakud8 from "../assets/eco-retreat/hirakud/gallery/hirakud8.jpg";
import Hirakud9 from "../assets/eco-retreat/hirakud/gallery/hirakud9.jpg";
import Hirakud10 from "../assets/eco-retreat/hirakud/gallery/hirakud10.jpeg";
import Hirakud11 from "../assets/eco-retreat/hirakud/gallery/hirakud11.jpeg";
import Hirakud12 from "../assets/eco-retreat/hirakud/gallery/hirakud12.jpeg";
import Hirakud13 from "../assets/eco-retreat/hirakud/gallery/hirakud13.jpg";
import Hirakud14 from "../assets/eco-retreat/hirakud/gallery/hirakud14.jpg";
import Hirakud15 from "../assets/eco-retreat/hirakud/gallery/hirakud15.jpg";

import HirakudPremiumSwissCottage from '../assets/eco-retreat/hirakud/room/Premium-Swiss-Cottage/premium-swiss-cottage1.jpg';

import HirakudDam from '../assets/attractions/hirakud/hirakud-dam.jpg';
import DebrigarhWildlifeSanctuary from '../assets/attractions/hirakud/Debrigarh-Wildlife-Sanctuary.jpg';
import MaaSamaleswariTemple from '../assets/attractions/hirakud/Maa-Samaleswari-Temple.jpg';

import HirakudExploreImg from '../assets/eco-retreat/hirakud/explore/Hirakud-dining.jpg';

// BHITARKANIKA
import Bhitarkanika1 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika1.jpg";
import Bhitarkanika2 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika2.jpg";
import Bhitarkanika3 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika3.jpg";
import Bhitarkanika4 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika4.jpg";
import Bhitarkanika5 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika5.jpg";
import Bhitarkanika6 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika6.jpg";
import Bhitarkanika7 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika7.jpg";
import Bhitarkanika8 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika8.jpg";
import Bhitarkanika9 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika9.jpg";
import Bhitarkanika10 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika10.jpg";
import Bhitarkanika11 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika11.jpg";
import Bhitarkanika12 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika12.jpg";
import Bhitarkanika13 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika13.jpg";
import Bhitarkanika14 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika14.jpg";
import Bhitarkanika15 from "../assets/eco-retreat/bhitarkanika/gallery/bhitarkanika15.jpg";

import BhitarkanikaDeluxeSwissCottage from '../assets/eco-retreat/bhitarkanika/room/Deluxe-Swiss-Cottage/deluxe-swiss-cottage1.jpg';
import BhitarkanikaPremiumSwissCottage from '../assets/eco-retreat/bhitarkanika/room/Premium-Swiss-Cottage/premium-swiss-cottage1.jpg';

import BhitarkanikaNationalPark from '../assets/attractions/bhitarkanika/bhitarkanika-national-park.jpg';
import BoatingInTheCreek from '../assets/attractions/bhitarkanika/Boating-bhitarkanika.jpg';
import BaruneiForest from '../assets/attractions/bhitarkanika/Bhitarkanika-Nature-walk.jpg';

import BhitarkanikaExploreImg from '../assets/eco-retreat/bhitarkanika/explore/bhitarkanika-archery.jpg';

const ecoRetreatData = {
  konark: {
    name: "Eco Retreat Konark",
    location: "konark",
    images: [
      Konark1,
      Konark2,
      Konark3,
      Konark4,
      Konark5,
      Konark6,
      Konark7,
      Konark8,
      Konark9,
      Konark10,
      Konark11,
      Konark12,
      Konark13,
      Konark14,
      Konark15,
      Konark16,
      Konark17,
      Konark18,
      Konark19,
      Konark20,
      Konark21,
      Konark22,
      Konark23,
      Konark24,
      Konark25,
      Konark26,
      Konark27
    ],
    price: {
      startingFrom: 5000,
      currency: "INR",
    },
    facilities: [
      "100% Safe & Hygienic",
      "24x7 Assistance",
      "Restaurant Dining",
      "Air Conditioning / Heating",
      "Beach Activities",
      "Water Sports",
      "Guided Tours",
      "Beach Bar",
      "Evening Entertainment",
      "Kids Area",
      "Conference Facility",
      "Doctor on Call",
      "Waterside Spa",
      "Well Appointed Toiletries",
    ],
    activities: {
      "Water Sports":
        "Make the most of your visit and head down for a range of exciting motorised and non-motorised watersports.",
      Recreation:
        "Rifle Shooting, Archery, ATVs, Bicycles, Beach Volleyball, etc.",
      "Evening Entertainment":
        "Entertainment begins with sun down music flowing into curated cultural performances & winding with a selection of romantic melodies.",
      "Yoga Workshops":
        "Indulge in learning while holidaying from experts of sand art, yoga, zumba & wellness, surfing, etc.",
      "Culinary Experience":
        "Enjoy an amazing selection of global cuisines with delicious, exciting & creative pre-designed menus spread over the various meals with optional beach side bar, evening barbeques or chai-tapri to engage with!",
      "Guided Tours":
        "Invent a new road to explore the unexplored with our friendly and professional guided tours.",
      Spa: "Waterside Spa is a relaxed massage centre offering a multitude of wellness treatments.",
      Conferencing:
        "The Eco Retreat conferencing comes with a special venue to conduct MICE / Training programs in a separate conference hall with 150 people capacity.",
      "Private Celebrations":
        "Celebrate your momentus occasions by booking exclusive areas for lunches and dinners like our Elevated Machaan Decks, Beachside Cabanas, etc.",
    },
    rooms: [
      {
        name: "Deluxe Swiss Cottage",
        images: [KonarkDeluxeSwissCottage],
        facilities: [
          "Air Conditioning",
          "WiFi",
          "King-Size Bed",
          "En Suite Bathroom",
          "Complimentary Breakfast",
        ],
      },
      {
        name: "Premium Swiss Cottage",
        images: [KonarkPremiumSwissCottage],
        facilities: [
          "Private Patio",
          "24x7 Assistance",
          "Spacious Interiors",
          "King-Size Bed",
          "Beach View",
        ],
      },
      {
        name: "Royal Luxury Swiss Cottage ",
        images: [KonarkRoyalLuxurySwissCottage],
        facilities: [
          "Private Patio",
          "24x7 Assistance",
          "Spacious Interiors",
          "King-Size Bed",
          "Beach View",
        ],
      },
      {
        name: "Presidential Suite ",
        images: [KonarkPresidentialSuite],
        facilities: [
          "Private Patio",
          "24x7 Assistance",
          "Spacious Interiors",
          "King-Size Bed",
          "Beach View",
        ],
      },
    ],
    cottages: [
      { exploreImages: KonarkExploreImg }, // This is the first element, used only for the explore image
      {
        name: "Deluxe Swiss Cottage",
        icon: DeluxeSwissCottageIcon,
        description: "With a comfortable twin / double bed along with a spacious porch and attached bathroom.",
      },
      {
        name: "Premium Swiss Cottage",
        icon: PremiumSwissCottageIcon,
        description: "Comfortable twin / double bed with a spacious sitting space to relax and en suite bathroom.",
      },
      {
        name: "Royal Luxury Swiss Cottage",
        icon: RoyalLuxurySwissCottageIcon,
        description: "A king-sized bedroom with a living room and a private dining area.",
      },
      {
        name: "Presidential Suite",
        icon: PresidentialSuiteIcon,
        description: "Two king-sized bedrooms with individual dressing cum bathroom along with a common living and a private lounge area.",
      },
    ],
    activities: [
      {
        name: "Water Sports",
        icon: Activity1,
        description: "Make the most of your visit and head down for a range of exciting motorised and non-motorised watersports.",
      },
      {
        name: "Recreation",
        icon: Activity2,
        description: "Rifle Shooting, Archery, ATVs, Bicycles, Beach Volleyball, etc.",
      },
      {
        name: "Evening Entertainment",
        icon: Activity3,
        description: "Entertainment begins with sun down music flowing into curated cultural performances & winding with a selection of romantic melodies.",
      },
      {
        name: "Workshops",
        icon: Activity4,
        description: "Indulge in learning while holidaying from experts of sand art, yoga, zumba & wellness, surfing, etc.",
      },
      {
        name: "Culinary Experience",
        icon: Activity5,
        description: "No holiday is complete without a delightful culinary experience. Enjoy an amazing selection of global cuisines with delicious, exciting & creative pre-designed menus spread over the various meals with optional beach side bar, evening barbeques or chai-tapri to engage with!",
      },
      {
        name: "Guided Tours",
        icon: Activity6,
        description: "Invent a new road to explore the unexplored with our friendly and professional guided tours.",
      },
      {
        name: "Waterside Spa",
        icon: Activity7,
        description: "Waterside Spa is a relaxed massage centre offering a multitude of wellness treatments.",
      },
      {
        name: "Conferencing",
        icon: Activity8,
        description: "The Eco Retreat conferencing comes with a special venue to conduct MICE / Training programs in a separate conference hall with 150 people capacity.",
      },
      {
        name: "Private Celebrations",
        icon: Activity9,
        description: "Celebrate your momentus occasions by booking exclusive areas for lunches and dinners like our Elevated Machaan Decks, Beachside Cabanas, etc.",
      },
    ],
    howToReach: {
      byAir: {
        airport: "Bhubaneswar Airport",
        distance: "81 kms",
        time: "2 hrs",
      },
      byRail: [
        {
          station: "Bhubaneshwar Railway Station",
          distance: "81 kms",
          time: "1 hr 30 mins",
        },
        {
          station: "Cuttack Junction Railway Station",
          distance: "104 kms",
          time: "2 hrs",
        },
        {
          station: "Puri Railway Station",
          distance: "29 kms",
          time: "44 mins",
        },
      ],
      byRoad: [
        {
          city: "Bhubaneswar",
          distance: "85 kms",
          time: "1 hr 50 mins",
        },
        {
          city: "Puri",
          distance: "29 kms",
          time: "40 mins",
        },
        {
          city: "Cuttack",
          distance: "104 kms",
          time: "2 hrs 10 mins",
        },
        {
          city: "Jamshedpur",
          distance: "470 kms",
          time: "9 hrs 30 mins",
        },
        {
          city: "Vishakapatnam",
          distance: "473 kms",
          time: "9 hrs 30 mins",
        },
        {
          city: "Kolkata",
          distance: "529 kms",
          time: "11 hrs",
        },
      ],
    },
    topAttractions: [
      {
        name: "Konark Sun Temple",
        image: KonarkSunTemple
      },
      {
        name: "Konark Asi Museum ",
        image: KonarkAsiMuseum
      },
      {
        name: "Konark Jagannath Puri ",
        image: KonarkJagannathPuri
      },
    ],
  },
  satkosia: {
    name: "Eco Retreat Satkosia",
    location: "Satkosia",
    images: [
      Satkosia1,
      Satkosia2,
      Satkosia3,
      Satkosia4,
      Satkosia5,
      Satkosia6,
      Satkosia7,
      Satkosia8,
      Satkosia9,
      Satkosia10,
      Satkosia11,
      Satkosia12,
      Satkosia13,
      Satkosia14,
      Satkosia15,
    ],
    facilities: [
      "100% Safe & Hygienic",
      "24x7 Assistance",
      "Restaurant Dining",
      "Air Conditioning / Heating",
      "Beach Activities",
      "Water Sports",
      "Guided Tours",
      "Beach Bar",
      "Evening Entertainment",
      "Kids Area",
      "Conference Facility",
      "Doctor on Call",
      "Waterside Spa",
      "Well Appointed Toiletries",
    ],
    rooms: [
      {
        name: "Deluxe Swiss Cottage",
        images: [SatkosiaDeluxeSwissCottage],
        facilities: [
          "Air Conditioning",
          "WiFi",
          "King-Size Bed",
          "En Suite Bathroom",
          "Complimentary Breakfast",
        ],
      },
      {
        name: "Premium Swiss Cottage",
        images: [SatkosiaPremiumSwissCottage],
        facilities: [
          "Private Patio",
          "24x7 Assistance",
          "Spacious Interiors",
          "King-Size Bed",
          "Beach View",
        ],
      },
    ],
    cottages: [
      { exploreImages: SatkosiaExploreImg }, // This is the first element, used only for the explore image
      {
        name: "Deluxe Swiss Cottage",
        icon: DeluxeSwissCottageIcon,
        description: "With a comfortable twin / double bed along with a spacious porch and attached bathroom.",
      },
      {
        name: "Premium Swiss Cottage",
        icon: PremiumSwissCottageIcon,
        description: "Comfortable twin / double bed with a spacious sitting space to relax and en suite bathroom.",
      },
     
    ],
    activities: [
      {
        name: "Water Sports",
        icon: Activity1,
        description: "Make the most of your visit and head down for a range of exciting motorised and non-motorised watersports.",
      },
      {
        name: "Recreation",
        icon: Activity2,
        description: "Rifle Shooting, Archery, ATVs, Bicycles, Beach Volleyball, etc.",
      },
      {
        name: "Evening Entertainment",
        icon: Activity3,
        description: "Entertainment begins with sun down music flowing into curated cultural performances & winding with a selection of romantic melodies.",
      },
      {
        name: "Culinary Experience",
        icon: Activity5,
        description: "No holiday is complete without a delightful culinary experience. Enjoy an amazing selection of global cuisines with delicious, exciting & creative pre-designed menus spread over the various meals with optional beach side bar, evening barbeques or chai-tapri to engage with!",
      },
      {
        name: "Guided Tours",
        icon: Activity6,
        description: "Invent a new road to explore the unexplored with our friendly and professional guided tours.",
      },
      {
        name: "Private Celebrations",
        icon: Activity9,
        description: "Celebrate your momentus occasions by booking exclusive areas for lunches and dinners like our Elevated Machaan Decks, Beachside Cabanas, etc.",
      },
    ],
    howToReach: {
      byAir: {
        airport: "Bhubaneswar Airport",
        distance: "140 kms",
        time: "3 hrs 30 mins",
      },
      byRail: [
        {
          station: "Angul Railway Station",
          distance: "81 kms",
          time: "2 hrs",
        },
        {
          station: "Cuttack Railway Station",
          distance: "123 kms",
          time: "3 hrs",
        },
      ],
      byRoad: [
        {
          city: "Bhubaneswar",
          distance: "140 kms",
          time: "3 hrs",
        },
        
      ],
    },
    topAttractions: [
      {
        name: "Satkosia Tiger Reserve",
        image: SatkosiaTigerReserve
      },
      {
        name: "Ratnaganda Waterfall",
        image: RatnagandaWaterfall
      },
      {
        name: "Satkosia Gorge Sanactuary",
        image: SatkosiaGorgeSanactuary
      },
    ],
  },
  putsil: {
    name: "Eco Retreat Putsil",
    location: "Putsil",
    images: [
      Putsil1,
      Putsil2,
      Putsil3,
      Putsil4,
      Putsil5,
      Putsil6,
      Putsil7,
      Putsil8,
      Putsil9,
      Putsil10,
      Putsil11,
      Putsil12,
    ],
    facilities: [
      "100% Safe & Hygienic",
      "24x7 Assistance",
      "Restaurant Dining",
      "Air Conditioning / Heating",
      "Beach Activities",
      "Water Sports",
      "Guided Tours",
      "Beach Bar",
      "Evening Entertainment",
      "Kids Area",
      "Conference Facility",
      "Doctor on Call",
      "Waterside Spa",
      "Well Appointed Toiletries",
    ],
    rooms: [
      {
        name: "Deluxe Swiss Cottage",
        images: [PutsilDeluxeSwissCottage],
        facilities: [
          "Air Conditioning",
          "WiFi",
          "King-Size Bed",
          "En Suite Bathroom",
          "Complimentary Breakfast",
        ],
      },
      {
        name: "Premium Swiss Cottage",
        images: [PutsilPremiumSwissCottage],
        facilities: [
          "Private Patio",
          "24x7 Assistance",
          "Spacious Interiors",
          "King-Size Bed",
          "Beach View",
        ],
      },
    ],
    cottages: [
      { exploreImages: PutsilExploreImg }, // This is the first element, used only for the explore image
      {
        name: "Deluxe Swiss Cottage",
        icon: DeluxeSwissCottageIcon,
        description: "With a comfortable twin / double bed along with a spacious porch and attached bathroom.",
      },
      {
        name: "Premium Swiss Cottage",
        icon: PremiumSwissCottageIcon,
        description: "Comfortable twin / double bed with a spacious sitting space to relax and en suite bathroom.",
      },
     
    ],
    activities: [
      {
        name: "Recreation",
        icon: Activity2,
        description: "Rifle Shooting, Archery, ATVs, Bicycles, Beach Volleyball, etc.",
      },
      {
        name: "Evening Entertainment",
        icon: Activity3,
        description: "Entertainment begins with sun down music flowing into curated cultural performances & winding with a selection of romantic melodies.",
      },
      {
        name: "Culinary Experience",
        icon: Activity5,
        description: "No holiday is complete without a delightful culinary experience. Enjoy an amazing selection of global cuisines with delicious, exciting & creative pre-designed menus spread over the various meals with optional beach side bar, evening barbeques or chai-tapri to engage with!",
      },
      {
        name: "Guided Tours",
        icon: Activity6,
        description: "Invent a new road to explore the unexplored with our friendly and professional guided tours.",
      },
      {
        name: "Private Celebrations",
        icon: Activity9,
        description: "Celebrate your momentus occasions by booking exclusive areas for lunches and dinners like our Elevated Machaan Decks, Beachside Cabanas, etc.",
      },
    ],
    howToReach: {
      byAir: {
        airport: "Bhubaneswar Airport",
        distance: "493 kms",
        time: "10 hrs",
      },
      byRail: [
        {
          station: "Koraput Station",
          distance: "41 kms",
          time: "1 hrs",
        },
      ],
      byRoad: [
        {
          city: "Bhubaneswar",
          distance: "493 kms",
          time: "10 hrs",
        },
        {
          city: "Brahmapur",
          distance: "326 kms",
          time: "7 hrs 23 mins",
        },
        {
          city: "Cuttack",
          distance: "512 kms",
          time: "11 hrs",
        },
        {
          city: "Koraput",
          distance: "41 kms",
          time: "1 hrs",
        },
        {
          city: "Raipur",
          distance: "392 kms",
          time: "9 hrs",
        },
        {
          city: "Jagdalpur",
          distance: "141 kms",
          time: "3 hrs 30 mins",
        },
        {
          city: "Visakhapatnam",
          distance: "192 kms",
          time: "5 hrs 10 mins",
        },
        
      ],
    },
    topAttractions: [
      {
        name: "Sabar Srikhetra",
        image: SabarSrikhetra
      },
      {
        name: "Tribal Museum",
        image: TribalMuseum
      },
      {
        name: "Duduma Waterfalls",
        image: DudumaWaterfalls
      },
    ],
  },
  sonapur: {
    name: "Eco Retreat Sonapur",
    location: "Sonapur",
    images: [
      Sonapur1,
      Sonapur2,
      Sonapur3,
      Sonapur4,
      Sonapur5,
      Sonapur6,
      Sonapur7,
      Sonapur8,
      Sonapur9,
      Sonapur10,
      Sonapur11,
      Sonapur12,
    ],
    facilities: [
      "100% Safe & Hygienic",
      "24x7 Assistance",
      "Restaurant Dining",
      "Air Conditioning / Heating",
      "Beach Activities",
      "Water Sports",
      "Guided Tours",
      "Beach Bar",
      "Evening Entertainment",
      "Kids Area",
      "Conference Facility",
      "Doctor on Call",
      "Waterside Spa",
      "Well Appointed Toiletries",
    ],
    rooms: [
      {
        name: "Deluxe Swiss Cottage",
        images: [SonapurDeluxeSwissCottage],
        facilities: [
          "Air Conditioning",
          "WiFi",
          "King-Size Bed",
          "En Suite Bathroom",
          "Complimentary Breakfast",
        ],
      },
      {
        name: "Premium Swiss Cottage",
        images: [SonapurPremiumSwissCottage],
        facilities: [
          "Private Patio",
          "24x7 Assistance",
          "Spacious Interiors",
          "King-Size Bed",
          "Beach View",
        ],
      },
    ],
    cottages: [
      { exploreImages: SonapurExploreImg }, // This is the first element, used only for the explore image
      {
        name: "Deluxe Swiss Cottage",
        icon: DeluxeSwissCottageIcon,
        description: "With a comfortable twin / double bed along with a spacious porch and attached bathroom.",
      },
      {
        name: "Premium Swiss Cottage",
        icon: PremiumSwissCottageIcon,
        description: "Comfortable twin / double bed with a spacious sitting space to relax and en suite bathroom.",
      },
     
    ],
    activities: [
      {
        name: "Water Sports",
        icon: Activity1,
        description: "Make the most of your visit and head down for a range of exciting motorised and non-motorised watersports.",
      },
      {
        name: "Recreation",
        icon: Activity2,
        description: "Rifle Shooting, Archery, ATVs, Bicycles, Beach Volleyball, etc.",
      },
      {
        name: "Evening Entertainment",
        icon: Activity3,
        description: "Entertainment begins with sun down music flowing into curated cultural performances & winding with a selection of romantic melodies.",
      },
      {
        name: "Culinary Experience",
        icon: Activity5,
        description: "No holiday is complete without a delightful culinary experience. Enjoy an amazing selection of global cuisines with delicious, exciting & creative pre-designed menus spread over the various meals with optional beach side bar, evening barbeques or chai-tapri to engage with!",
      },
      {
        name: "Guided Tours",
        icon: Activity6,
        description: "Invent a new road to explore the unexplored with our friendly and professional guided tours.",
      },
      {
        name: "Conferencing",
        icon: Activity8,
        description: "The Eco Retreat conferencing comes with a special venue to conduct MICE / Training programs in a separate conference hall with 150 people capacity.",
      },
      {
        name: "Private Celebrations",
        icon: Activity9,
        description: "Celebrate your momentus occasions by booking exclusive areas for lunches and dinners like our Elevated Machaan Decks, Beachside Cabanas, etc.",
      },
    ],
    howToReach: {
      byAir: {
        airport: "Bhubaneswar Airport",
        distance: "196 kms",
        time: "4 hrs 19 mins",
      },
      byRail: [
        {
          station: "Berhampur Station",
          distance: "25 kms",
          time: "45 mins",
        },
        {
          station: "Ichchapuram Station",
          distance: "18 kms",
          time: "35 mins",
        },
      ],
      byRoad: [
        {
          city: "Bhubaneswar",
          distance: "200 kms",
          time: "4 hrs 30 mins",
        },
        {
          city: "Brahmapur",
          distance: "29 kms",
          time: "46 mins",
        },
        {
          city: "Cuttack",
          distance: "488 kms",
          time: "11 hrs 30 mins",
        },
        {
          city: "Koraput",
          distance: "335 kms",
          time: "14 hrs 30 mins",
        },
        {
          city: "Rourkela",
          distance: "448 kms",
          time: "11 hrs 30 mins",
        },
        {
          city: "Ichchapuram",
          distance: "20 kms",
          time: "30 mins",
        },
        {
          city: "Kolkata",
          distance: "635 kms",
          time: "14 hrs 30 mins",
        },
        
      ],
    },
    topAttractions: [
      {
        name: "Sureswari Temple",
        image: SureswariTemple
      },
      {
        name: "Lankeswari Temple",
        image: LankeswariTemple
      },
      {
        name: "Subarnameru Shiva Temple",
        image: SubarnameruShivaTemple
      },
    ],
  },
  daringbadi: {
    name: "Eco Retreat Daringbadi",
    location: "Daringbadi",
    images: [
      Daringbadi1,
      Daringbadi2,
      Daringbadi3,
      Daringbadi4,
      Daringbadi5,
      Daringbadi6,
      Daringbadi7,
      Daringbadi8,
      Daringbadi9,
      Daringbadi10,
      Daringbadi11,
      Daringbadi12,
      Daringbadi13,
      Daringbadi14,
      Daringbadi15,
    ],
    facilities: [
      "100% Safe & Hygienic",
      "24x7 Assistance",
      "Restaurant Dining",
      "Air Conditioning / Heating",
      "Beach Activities",
      "Water Sports",
      "Guided Tours",
      "Beach Bar",
      "Evening Entertainment",
      "Kids Area",
      "Conference Facility",
      "Doctor on Call",
      "Waterside Spa",
      "Well Appointed Toiletries",
    ],
    rooms: [
      {
        name: "Deluxe Swiss Cottage",
        images: [DaringbadiDeluxeSwissCottage],
        facilities: [
          "Air Conditioning",
          "WiFi",
          "King-Size Bed",
          "En Suite Bathroom",
          "Complimentary Breakfast",
        ],
      },
      {
        name: "Premium Swiss Cottage",
        images: [DaringbadiPremiumSwissCottage],
        facilities: [
          "Private Patio",
          "24x7 Assistance",
          "Spacious Interiors",
          "King-Size Bed",
          "Beach View",
        ],
      },
    ],
    cottages: [
      { exploreImages: DaringbadiExploreImg }, // This is the first element, used only for the explore image
      {
        name: "Deluxe Swiss Cottage",
        icon: DeluxeSwissCottageIcon,
        description: "With a comfortable twin / double bed along with a spacious porch and attached bathroom.",
      },
      {
        name: "Premium Swiss Tent",
        icon: PremiumSwissCottageIcon,
        description: "Comfortable twin / double bed with a spacious sitting space to relax and en suite bathroom.",
      },
     
    ],
    activities: [
      {
        name: "Recreation",
        icon: Activity2,
        description: "Rifle Shooting, Archery, ATVs, Bicycles, Beach Volleyball, etc.",
      },
      {
        name: "Evening Entertainment",
        icon: Activity3,
        description: "Entertainment begins with sun down music flowing into curated cultural performances & winding with a selection of romantic melodies.",
      },
      {
        name: "Culinary Experience",
        icon: Activity5,
        description: "No holiday is complete without a delightful culinary experience. Enjoy an amazing selection of global cuisines with delicious, exciting & creative pre-designed menus spread over the various meals with optional beach side bar, evening barbeques or chai-tapri to engage with!",
      },
      {
        name: "Guided Tours",
        icon: Activity6,
        description: "Invent a new road to explore the unexplored with our friendly and professional guided tours.",
      },
      {
        name: "Private Celebrations",
        icon: Activity9,
        description: "Celebrate your momentus occasions by booking exclusive areas for lunches and dinners like our Elevated Machaan Decks, Beachside Cabanas, etc.",
      },
    ],
    howToReach: {
      byAir: {
        airport: "Bhubaneswar Airport",
        distance: "248 kms",
        time: "6 hrs",
      },
      byRail: [
        {
          station: "Berhampur Station",
          distance: "123 kms",
          time: "3 hrs 10 mins",
        },
        
      ],
      byRoad: [
        {
          city: "Bhubaneswar",
          distance: "250 kms",
          time: "6 hrs",
        },
        
      ],
    },
    topAttractions: [
      {
        name: "Sunse Point",
        image: SunsetPoint
      },
      {
        name: "Midubanda Waterfall",
        image: MidubandaWaterfall
      },
      {
        name: "Coffee Garden",
        image: CoffeeGarden
      },
    ],
  },
  hirakud: {
    name: "Eco Retreat Hirakud",
    location: "Hirakud",
    images: [
      Hirakud1,
      Hirakud2,
      Hirakud3,
      Hirakud4,
      Hirakud5,
      Hirakud6,
      Hirakud7,
      Hirakud8,
      Hirakud9,
      Hirakud10,
      Hirakud11,
      Hirakud12,
      Hirakud13,
      Hirakud14,
      Hirakud15,
    ],
    facilities: [
      "100% Safe & Hygienic",
      "24x7 Assistance",
      "Restaurant Dining",
      "Air Conditioning / Heating",
      "Beach Activities",
      "Water Sports",
      "Guided Tours",
      "Beach Bar",
      "Evening Entertainment",
      "Kids Area",
      "Conference Facility",
      "Doctor on Call",
      "Waterside Spa",
      "Well Appointed Toiletries",
    ],
    rooms: [
      {
        name: "Premium Swiss Cottage",
        images: [HirakudPremiumSwissCottage],
        facilities: [
          "Private Patio",
          "24x7 Assistance",
          "Spacious Interiors",
          "King-Size Bed",
          "Beach View",
        ],
      },
    ],
    cottages: [
      { exploreImages: HirakudExploreImg }, // This is the first element, used only for the explore image
      {
        name: "Premium Swiss Tent",
        icon: PremiumSwissCottageIcon,
        description: "Comfortable twin / double bed with a spacious sitting space to relax and en suite bathroom.",
      },
     
    ],
    activities: [
      {
        name: "Water Sports",
        icon: Activity1,
        description: "Make the most of your visit and head down for a range of exciting motorised and non-motorised watersports.",
      },
      {
        name: "Recreation",
        icon: Activity2,
        description: "Rifle Shooting, Archery, ATVs, Bicycles, Beach Volleyball, etc.",
      },
      {
        name: "Evening Entertainment",
        icon: Activity3,
        description: "Entertainment begins with sun down music flowing into curated cultural performances & winding with a selection of romantic melodies.",
      },
      {
        name: "Culinary Experience",
        icon: Activity5,
        description: "No holiday is complete without a delightful culinary experience. Enjoy an amazing selection of global cuisines with delicious, exciting & creative pre-designed menus spread over the various meals with optional beach side bar, evening barbeques or chai-tapri to engage with!",
      },
      {
        name: "Guided Tours",
        icon: Activity6,
        description: "Invent a new road to explore the unexplored with our friendly and professional guided tours.",
      },
      {
        name: "Private Celebrations",
        icon: Activity9,
        description: "Celebrate your momentus occasions by booking exclusive areas for lunches and dinners like our Elevated Machaan Decks, Beachside Cabanas, etc.",
      },
    ],
    howToReach: {
      byAir: {
        airport: "Jharsuguda Airport",
        distance: "40 kms",
        time: "49 mins",
      },
      byRail: [
        {
          station: "Sambalpur Railway Station",
          distance: "16 kms",
          time: "30 mins",
        },
        
      ],
      byRoad: [
        {
          city: "Sambalpur",
          distance: "16 kms",
          time: "30 mins",
        },
        
      ],
    },
    topAttractions: [
      {
        name: "Hirakud Dam",
        image: HirakudDam
      },
      {
        name: "Debrigarh Wildlife Sanctuary",
        image: DebrigarhWildlifeSanctuary
      },
      {
        name: "Maa Samaleswari Temple",
        image: MaaSamaleswariTemple
      },
    ],
  },
  bhitarkanika: {
    name: "Eco Retreat Bhitarkanika",
    location: "Bhitarkanika",
    images: [
      Bhitarkanika1,
      Bhitarkanika2,
      Bhitarkanika3,
      Bhitarkanika4,
      Bhitarkanika5,
      Bhitarkanika6,
      Bhitarkanika7,
      Bhitarkanika8,
      Bhitarkanika9,
      Bhitarkanika10,
      Bhitarkanika11,
      Bhitarkanika12,
      Bhitarkanika13,
      Bhitarkanika14,
      Bhitarkanika15,
    ],
    facilities: [
      "100% Safe & Hygienic",
      "24x7 Assistance",
      "Restaurant Dining",
      "Air Conditioning / Heating",
      "Beach Activities",
      "Water Sports",
      "Guided Tours",
      "Beach Bar",
      "Evening Entertainment",
      "Kids Area",
      "Conference Facility",
      "Doctor on Call",
      "Waterside Spa",
      "Well Appointed Toiletries",
    ],
    rooms: [
      {
        name: "Deluxe Swiss Cottage",
        images: [BhitarkanikaDeluxeSwissCottage],
        facilities: [
          "Air Conditioning",
          "WiFi",
          "King-Size Bed",
          "En Suite Bathroom",
          "Complimentary Breakfast",
        ],
      },
      {
        name: "Premium Swiss Cottage",
        images: [BhitarkanikaPremiumSwissCottage],
        facilities: [
          "Private Patio",
          "24x7 Assistance",
          "Spacious Interiors",
          "King-Size Bed",
          "Beach View",
        ],
      },
    ],
    cottages: [
      { exploreImages: BhitarkanikaExploreImg }, // This is the first element, used only for the explore image
      {
        name: "Deluxe Swiss Cottage",
        icon: DeluxeSwissCottageIcon,
        description: "With a comfortable twin / double bed along with a spacious porch and attached bathroom.",
      },
      {
        name: "Premium Swiss Tent",
        icon: PremiumSwissCottageIcon,
        description: "Comfortable twin / double bed with a spacious sitting space to relax and en suite bathroom.",
      },
     
    ],
    activities: [
      {
        name: "Water Sports",
        icon: Activity1,
        description: "Make the most of your visit and head down for a range of exciting motorised and non-motorised watersports.",
      },
      {
        name: "Recreation",
        icon: Activity2,
        description: "Rifle Shooting, Archery, ATVs, Bicycles, Beach Volleyball, etc.",
      },
      
      {
        name: "Culinary Experience",
        icon: Activity5,
        description: "No holiday is complete without a delightful culinary experience. Enjoy an amazing selection of global cuisines with delicious, exciting & creative pre-designed menus spread over the various meals with optional beach side bar, evening barbeques or chai-tapri to engage with!",
      },
      {
        name: "Guided Tours",
        icon: Activity6,
        description: "Invent a new road to explore the unexplored with our friendly and professional guided tours.",
      },
      {
        name: "Private Celebrations",
        icon: Activity9,
        description: "Celebrate your momentus occasions by booking exclusive areas for lunches and dinners like our Elevated Machaan Decks, Beachside Cabanas, etc.",
      },
    ],
    howToReach: {
      byAir: {
        airport: "Bhubaneswar Airport",
        distance: "130 kms",
        time: "3 hrs 50 mins",
      },
      byRail: [
        {
          station: "Kendrapara Railway Station",
          distance: "48 kms",
          time: "1 hrs 45 mins",
        },
        {
          station: "Cuttack Junction Railway Station",
          distance: "107 kms",
          time: "2 hrs 30 mins",
        },
      ],
      byRoad: [
        {
          city: "Bhubaneswar",
          distance: "130 kms",
          time: "3 hrs 30 mins",
        },
        {
          city: "Balasore",
          distance: "179 kms",
          time: "4 hrs",
        },
        {
          city: "Chandipur",
          distance: "177 kms",
          time: "5 hrs",
        },
        {
          city: "Cuttack",
          distance: "107 kms",
          time: "3 hrs",
        },
        {
          city: "Jamshedpur (Via Baripada, Balasore)",
          distance: "375 kms",
          time: "8 hrs",
        },
        {
          city: "Kendrapara",
          distance: "48 kms",
          time: "1 hrs 30 mins",
        },
        {
          city: "Kharagpur (via Balasore)",
          distance: "320 kms",
          time: "8 hrs",
        },
        {
          city: "Kolkata",
          distance: "426 kms",
          time: "10 hrs",
        },
        
      ],
    },
    topAttractions: [
      {
        name: "Bhitarkanika National Park",
        image: BhitarkanikaNationalPark
      },
      {
        name: "Boating In The Creek",
        image: BoatingInTheCreek
      },
      {
        name: "Barunei Forest",
        image: BaruneiForest
      },
    ],
  },
};

export default ecoRetreatData;
